import React, { useState, useRef } from "react";
import './addproduct.css';
import gallery from '../assets/images/gallery.png';

const AddProduct = ({ onProductAdd, onClose, product }) => {
    const [img, setImg] = useState(product?.img || null); // Initialize with existing image or null
    const [productname, setProductName] = useState(product?.productname || '');
    const [brand, setBrand] = useState(product?.brand || '');
    const [price, setPrice] = useState(product?.price || '');
    const [category, setCategory] = useState(product?.category || '');
    const [error, setError] = useState({});
    const fileInputRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const formData = new FormData();
            formData.append("productname", productname);
            formData.append("brand", brand);
            formData.append("price", price);
            formData.append("category", category);
            if (fileInputRef.current.files[0]) {
                formData.append("img", fileInputRef.current.files[0]);
            }
            onProductAdd(formData); // Pass FormData for image upload
        }
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'productname') setProductName(value);
        if (name === 'brand') setBrand(value);
        if (name === 'price') setPrice(value);
        if (name === 'category') setCategory(value);

        validateProduct({ name, value });
    };

    const validateProduct = ({ name, value }) => {
        let errorMsg = '';
        switch (name) {
            case 'productname':
                if (value.length < 3) {
                    
                    errorMsg = 'Enter alphabets';
                }
                break;

            case 'price':
                if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                    errorMsg = 'Enter valid price';
                }
                break;

            case 'brand':
                if (value.length< 2) {
                    errorMsg = 'Enter brand name';
                }
                break;

            default:
                break;
        }
        setError({ ...error, [name]: errorMsg });
    };

    const validateForm = () => {
        return Object.values(error).every((err) => err === '') &&
               productname && brand && price && category;
    };

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImg(reader.result);  // Store the image URL in the state
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="modal-overlay">
            <div className="form-container">
                <h3>Add Product</h3>
                <div className="img-container">
                    <button className="new" onClick={triggerFileInput}>
                        <img src={img || gallery} alt="Product" /> {/* Display uploaded image or default */}
                    </button>
                    <input type="file" accept="image/*" onChange={handleFile} ref={fileInputRef} style={{ display: 'none' }} />
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="input-box">
                       <input type="text" name="productname" value={productname} onChange={handleChange} autoComplete="off" />
                        <label>Product Name</label>
                        {error.productname && <small style={{ color: "red" }}>{error.productname}</small>}
                    </div>
        
                  <div className="input-box">
                        <input type="text" name="brand" value={brand} onChange={handleChange} autoComplete="off" />
                        <label>Brand</label>
                    {error.brand && <small style={{ color: "red" }}>{error.brand}</small>}
                    </div>
                
                    
                    <div className="input-box">
                        <input type="text" name="price" value={price} onChange={handleChange} autoComplete="off" />
                        <label>Price</label>
                        {error.price && <small style={{ color: "red" }}>{error.price}</small>}
                    </div>
                         <div>
                         <select name="category" value={category} onChange={handleChange} required>
                            <option value="" disabled>Select Category</option>
                            <option value="smartphones">Smartphones</option>
                            <option value="laptops">Laptops</option>
                            <option value="fragrances">Fragrances</option>
                            <option value="skincare">Skincare</option>
                            <option value="groceries">Groceries</option>
                            <option value="homedecoration">HomeDecoration</option>
                        </select>
                        </div>

                    <div className="btn-container">
                    <button type="button" className="back-btn" onClick={onClose}>Back</button>
                    <button className="add-btn" type="submit">Add</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddProduct;
